import { ButtonBaseProps } from '../ButtonBase/Component'
import { Spinner } from '../Spinner'
import { Typography } from '../Typography'
import { Container, StyledSpinner } from './styles'

export type ButtonVariant = 'contained' | 'outlined' | undefined

export interface ButtonProps extends ButtonBaseProps {
  children: React.ReactNode
  loading?: boolean
  icon?: React.ElementType
  suffixIcon?: React.ElementType
  ellipsis?: boolean
  textAlign?: string
}

export const Button = ({
  children,
  loading,
  icon: Icon,
  suffixIcon: SuffixIcon,
  ellipsis,
  textAlign,
  ...rest
}: ButtonProps) => (
  <Container loading={loading} {...rest}>
    {Icon && <Icon size="button" />}
    <Typography ellipsis={ellipsis} textAlign={textAlign} variant="button">
      {children}
    </Typography>
    {SuffixIcon && <SuffixIcon size="button" />}
    {loading && (
      <StyledSpinner data-testid="button-spinner">
        <Spinner />
      </StyledSpinner>
    )}
  </Container>
)

export const PrimaryButton = (props: ButtonProps) => (
  <Button {...props} variant="contained" />
)

export const SecondaryButton = (props: ButtonProps) => (
  <Button {...props} variant="outlined" />
)
